import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Logo, BillingSchedule } from '@livable/saas-react-components';
import { AppBar, Toolbar, Typography, FormGroup, FormControlLabel, Switch, Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// NOTE: Feature not implemented!
// import HeaderNotifications from 'src/components/shared/HeaderNotifications';
import HeaderSearch from 'src/components/general/HeaderSearch';
import { ProfileMenu } from 'src/components/layout/ProfileMenu';
import { useStore } from 'src/stores';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { BILLING_SCHEDULE_EVENT_ENUM, BILLING_SCHEDULE_EVENT_ENUM_TO_TITLE } from 'src/constants/billingSchedule';
import { api } from 'src/api';
import moment from 'moment';
import { hideContainerOverflow } from 'src/configs/pagesConfigs';
import { PmSubAccountsModal } from 'src/components/shared/PmSubAccountsModal';
export const SearchHeader = observer(props => {
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const history = useLocation();
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    billingSchedule = _useState2[0],
    setBillingSchedule = _useState2[1];
  const currentPath = history.pathname ? history.pathname : history.history.pathname;
  const handleTestModeSwitch = async () => {
    store.account.setIsEnablingDemoMode(true);
    await store.account.enableDemoPropertyAsync.run({
      isEnabled: !store.account.userProfile.isDemoModeEnabled
    });
    await store.account.refreshAccessTokenAsync.run();
    await store.portfolios.getExistingPortfoliosAsync.run();
    await store.company.getCompaniesAsync.run();
    // store.account.setIsEnablingDemoMode(false); // hide page loader, not disabling manually because it would be disabled on page refresh
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };
  const getBillingScheduleItemFields = (billingScheduleEvent, timeLeft) => {
    const resultFields = {};
    switch (billingScheduleEvent) {
      case BILLING_SCHEDULE_EVENT_ENUM.BillSubmissionDeadline:
        Object.assign(resultFields, {
          link: '/allocations'
        });
    }
    const daysLeft = moment(timeLeft).diff(moment(store.properties.serverBusinessDateOnly), 'days');
    if (daysLeft === 0) {
      Object.assign(resultFields, {
        status: 'error'
      });
    } else if (daysLeft <= 3) {
      Object.assign(resultFields, {
        status: 'warning'
      });
    }
    return resultFields;
  };
  const getBillingSchedule = async () => {
    const resp = await store.payment.getBillingScheduleAsync.run();
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      const resParsed = resp === null || resp === void 0 ? void 0 : resp.response.map(event => {
        const result = _objectSpread(_objectSpread(_objectSpread({}, Object.entries(BILLING_SCHEDULE_EVENT_ENUM_TO_TITLE[event === null || event === void 0 ? void 0 : event.billingScheduleEvent]).reduce((previousValue, currentValue) => {
          const _currentValue = _slicedToArray(currentValue, 2),
            key = _currentValue[0],
            value = _currentValue[1];
          return _objectSpread(_objectSpread({}, previousValue), {}, {
            [key]: t(value)
          });
        }, {})), getBillingScheduleItemFields(event === null || event === void 0 ? void 0 : event.billingScheduleEvent, event === null || event === void 0 ? void 0 : event.toBeAppliedOnDateOnly)), {}, {
          day: moment(event === null || event === void 0 ? void 0 : event.toBeAppliedOnDateOnly).format('D'),
          month: moment(event === null || event === void 0 ? void 0 : event.toBeAppliedOnDateOnly).format('MMM'),
          timeLeft: (event === null || event === void 0 ? void 0 : event.remainingDays) === 0 ? t('general.today') : t('shared_keys.days_left', {
            days: event === null || event === void 0 ? void 0 : event.remainingDays
          })
          // timeLeft: t('shared_keys.hours_left', { hours: 26 }), for hours not implemented
        });
        return result;
      });
      setBillingSchedule(resParsed);
    }
  };
  useEffect(() => {
    if (api.Account.isLoggedIn()) getBillingSchedule();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(AppBar, {
    "data-tut": "reactour__top-nav"
  }, store.account.userProfile.isDemoModeEnabled && /*#__PURE__*/React.createElement("div", {
    className: classes.testMode
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.testModeText
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "white"
  }, t('general.test_mode')))), /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement("div", {
    className: classes.contentL
  }, !hideContainerOverflow(currentPath) && /*#__PURE__*/React.createElement(Button, {
    "aria-label": "sidebar-menu",
    onClick: props.toggleSidebar,
    className: classes.sidebarMenuTrigger
  }, /*#__PURE__*/React.createElement("i", {
    className: classes.sidebarMenuTriggerIcon
  }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null))), /*#__PURE__*/React.createElement(Logo, {
    to: "/active_dashboard"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.contentR
  }, /*#__PURE__*/React.createElement(HeaderSearch, null), /*#__PURE__*/React.createElement("div", {
    className: "header-buttons"
  }, (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && /*#__PURE__*/React.createElement(Typography, {
    component: RouterLink,
    to: "/admin",
    variant: "h5",
    className: classes.currentCompany
  }, store.admin.companyName), !(store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && !store.company.companyFeatureStore.disableDemoMode && !store.company.companyFeatureStore.isAppfolio && false && /*#__PURE__*/React.createElement("div", {
    className: classes.testModeToggle
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    checked: store.account.userProfile.isDemoModeEnabled,
    control: /*#__PURE__*/React.createElement(Switch, null),
    onClick: handleTestModeSwitch,
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "primary"
    }, !store.account.userProfile.isDemoModeEnabled ? t('general.enable_test_mode') : t('general.disable_test_mode')),
    disabled: store.account.enableDemoPropertyAsync.inProgress || store.account.refreshAccessTokenAsync.inProgress
  }))), !!(billingSchedule !== null && billingSchedule !== void 0 && billingSchedule.length) && !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(BillingSchedule, {
    scheduleInfo: billingSchedule
  }), store.account.featureFlagsStore.getIsPmSubAccountsEnabled && false && /*#__PURE__*/React.createElement(PmSubAccountsModal, null), /*#__PURE__*/React.createElement(ProfileMenu, null)))));
});